import {
  SecondaryOptionHeader,
  SecondaryOptionText,
  SecondaryLinkOptionStyled,
  SecondaryTagOptionStyled,
  OpenNewWindow,
} from './QuickNav.styles';

import { PrimaryLink } from './PrimaryLink';

export interface SecondaryOptionProps {
  /** The title text of the dropdown option */
  title?: string;
  /** The link the dropdown option navigates to */
  href?: string;
  /** Subtext shown with the dropdown object */
  pageDescription?: string;
  /** Flag that when true, will not trigger a full page refresh on page change. This should be true for
   * any links to React pages
   */
  shouldNotReload?: boolean;
  shouldOpenInNewTab?: boolean;
}

export const SecondaryOption = ({
  title = '',
  href = '/',
  pageDescription = '',
  shouldNotReload = false,
  shouldOpenInNewTab = false,
  ...props
}: SecondaryOptionProps) => {
  if (shouldOpenInNewTab) {
    return (
      <PrimaryLink
        data-test={`quick-nav-supportlink`}
        data-support-link
        key={title}
        href={href}
        title={title}
        {...props}
      >
        <OpenNewWindow height={24} width={24} />
      </PrimaryLink>
    );
  }
  // Sets the content of the Option, depending on if there is a pageDecscription
  const OptionContent = (
    <>
      <SecondaryOptionHeader data-test="quick-nav-secondaryoption-header">
        {title}
      </SecondaryOptionHeader>
      <SecondaryOptionText data-test="quick-nav-secondaryoption-text">
        {pageDescription}
      </SecondaryOptionText>
    </>
  );

  // loads the Option content into an <a> or a <link> depending on if we are forcing a reload
  return shouldNotReload ? (
    <SecondaryLinkOptionStyled
      tabIndex={0}
      to={href}
      data-test="quick-nav-secondarylink"
      {...props}
    >
      {OptionContent}
    </SecondaryLinkOptionStyled>
  ) : (
    <SecondaryTagOptionStyled
      tabIndex={0}
      href={href}
      data-test="quick-nav-secondarytag"
      {...props}
    >
      {OptionContent}
    </SecondaryTagOptionStyled>
  );
};
